import React from 'react';

import PropTypes from 'prop-types';
import { FilterHullMaterialPropTypes } from '../../Filter/FilterHullMaterial';
import { useCollapsibleState } from '../FilterHelpers/useSRPFilters';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleHeader
} from '../../../../../components/Collapsible';
import { FilterHullMaterial } from '../../Filter';

const CollapsibleHullMaterial = ({
  label,
  facetConfig,
  handleDataChange,
  hullTypes,
  params,
  hullMaterial,
  position
}) => {
  const { isEnabled, isOpen } = useCollapsibleState( 'hullMaterial', facetConfig);
  if (!isEnabled) {
    return null;
  }
  return (
    <CollapsibleContent initialState={isOpen}>
      <CollapsibleHeader priority={0}>{label}</CollapsibleHeader>
      <Collapsible>
        <FilterHullMaterial
          handleDataChange={handleDataChange}
          hullTypes={hullTypes}
          params={params}
          selectedHullTypes={hullMaterial}
          position={position}
        />
      </Collapsible>
    </CollapsibleContent>
  );
};

CollapsibleHullMaterial.propTypes = {
  ...FilterHullMaterialPropTypes,
  label: PropTypes.string,
  facetConfig: PropTypes.array
};

export { CollapsibleHullMaterial };
